import {
    INTEGRATION_UPDATE_MELI_PUBLICATION_BEGIN,
    INTEGRATION_UPDATE_MELI_PUBLICATION_SUCCESS,
    INTEGRATION_UPDATE_MELI_PUBLICATION_FAILURE,
  } from '../constants'
  import { BFFAgent } from 'BFFAgent'
import { ErrorAction, SuccessAction } from 'common/redux/toasts';
import { closeSideSheet } from './closeSideSheet';
import { getPublications } from './getPublications';
  
  export function updateMeliPublication(data, catalogId, is0Km, reloadData) {
    return async dispatch => {
      dispatch({
        type: INTEGRATION_UPDATE_MELI_PUBLICATION_BEGIN
      })
  
      try {
          const result = await BFFAgent.Integrations.updatePublication(data)

        dispatch({
            type: INTEGRATION_UPDATE_MELI_PUBLICATION_SUCCESS,
            data: result,
        })

        dispatch(
            SuccessAction({ title: 'Actualizaste la publicación correctamente' })
        )

        dispatch(getPublications(catalogId, null, is0Km))
        dispatch(closeSideSheet())
      } catch (error) {
        console.error(error)
        const showErrorMessage = error.response?.data?.showErrorMessage
        const errorMsg = showErrorMessage ? error.message : 'Algo salió mal, intentá de nuevo en unos minutos.'
        dispatch(ErrorAction({ title: errorMsg }))
        dispatch({ type: INTEGRATION_UPDATE_MELI_PUBLICATION_FAILURE })
        if (showErrorMessage) {
          reloadData()
          dispatch(closeSideSheet())
        }
      }
    }
  }

  export function reducer(state, action) {
    switch (action.type) {
        case INTEGRATION_UPDATE_MELI_PUBLICATION_BEGIN:
            return {
                ...state,
                isLoadingCreateUpdateMeliPublish: true,
            }

        case INTEGRATION_UPDATE_MELI_PUBLICATION_SUCCESS:
        case INTEGRATION_UPDATE_MELI_PUBLICATION_FAILURE:
            return {
                ...state,
                isLoadingCreateUpdateMeliPublish: false,
            }

        default:
            return state
    }
}
  
